import { combineReducers } from 'redux';

import { PlanUnitMix } from 'components/types';

import { LastUsedPlanunitAction } from './actionCreators';

function lastUsedPlanunit(
  state: PlanUnitMix[] = [],
  { type, payload }: LastUsedPlanunitAction
) {
  switch (type) {
    case 'SET_QUALITY_MONITOR_LAST_USED_PLANUNIT':
      return payload;
    default:
      return state;
  }
}

export default combineReducers({
  lastUsedPlanunit
});
